import { render, staticRenderFns } from "./Lifeline.vue?vue&type=template&id=63f48820&scoped=true&"
import script from "./Lifeline.vue?vue&type=script&lang=js&"
export * from "./Lifeline.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63f48820",
  null
  
)

export default component.exports